import React from "react";
import { Box, Typography, Button, IconButton, TextField } from "@mui/material";
import DeleteIcon from "@mui/icons-material/DeleteRounded";

const LogoMenu = ({
  toggleDrawer,
  editItem,
  handleSave,
  logo,
  handleApi,
  isMobile,
}) => {
  let logoType = "logo";
  let logoHeight = "75";
  let logoWidth = "75";

  if (isMobile) {
    logoType = "mobileLogo";
    logoHeight = "50";
    logoWidth = "50";
  }
  const [image, setImage] = React.useState(logo.logo);
  const [dimensions, setDimensions] = React.useState({
    height: logo.height || logoHeight,
    width: logo.width || logoWidth,
  });

  const handleDimensionChange = (e) => {
    const { name, value } = e.target;
    const numValue = parseInt(value);

    // Enforce max constraints
    if (name === "height" && numValue > 90) return;
    if (name === "width" && numValue > 550) return;

    setDimensions((prev) => ({
      ...prev,
      [name]: value,
    }));
    handleSave(logoType, name, value);
  };



  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (file) {
      try {
        const base64String = await convertToBase64(file);
        setImage(base64String);
        handleSave(logoType, "logo", base64String);
      } catch (error) {
        console.error("Error converting file to Base64:", error);
      }
    }
  };

  const handleImageDelete = () => {
    setImage(null);
    handleSave(logoType, "logo", null);
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        borderRadius: "8px",
        backgroundColor: "#fff",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#333",
          color: "#fff",
          padding: "5px",
          marginBottom: "16px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold", fontSize: "16px" }}>
          Edit Logo
        </Typography>
        <Button
          variant="text"
          sx={{ fontWeight: "bold", color: "#fff" }}
          onClick={() => {
            toggleDrawer(true, editItem.index, "customizeHeader");
          }}
        >
          Back
        </Button>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          height: "100%",
          width: "100%",
        }}
      >
        <Box
          sx={{
            padding: "0 10px",
            flex: 1,
            display: "flex",
            flexDirection: "column",
            rowGap: "15px",
            width: "100%",
          }}
        >
          {image ? (
            <Box sx={{ opacity: 0.7 }}>
              <img
                src={image}
                alt="uploaded"
                style={{
                  width: `${dimensions.width}px`,
                  height: `${dimensions.height}px`,
                  objectFit: "cover",
                  display: "block",
                  marginBottom: "8px",
                }}
              />
              <IconButton
                size="small"
                onClick={handleImageDelete}
                sx={{
                  color: "red",
                  cursor: "pointer",
                }}
              >
                <DeleteIcon />
              </IconButton>
            </Box>
          ) : (
            <Button
              variant="outlined"
              component="label"
              sx={{
                width: "fit-content",
                opacity: 0.7,
                cursor: "pointer",
              }}
            >
              Select Logo Image
              <input
                type="file"
                accept="image/*"
                hidden
                onChange={handleImageUpload}
              />
            </Button>
          )}
          {image && (
            <>
              <TextField
                label="Height (max 90px)"
                type="number"
                name="height"
                value={dimensions.height}
                onChange={handleDimensionChange}
                fullWidth
                InputProps={{
                  inputProps: {
                    max: 90,
                    min: 1,
                  },
                }}
                sx={{ mt: 2 }}
              />

              <TextField
                label="Width (max 550px)"
                type="number"
                name="width"
                value={dimensions.width}
                onChange={handleDimensionChange}
                fullWidth
                InputProps={{
                  inputProps: {
                    max: 550,
                    min: 1,
                  },
                }}
              />
            </>
          )}
        </Box>
        <Button
          variant="contained"
          color="success"
          fullWidth
          sx={{
            fontSize: "12px",
            padding: "6px",
            width: "90%",
            borderRadius: "50px",
            margin: "30px 0 20px 0",
          }}
          onClick={handleApi}
        >
          Save
        </Button>
      </Box>
    </Box>
  );
};

export default LogoMenu;
